import { render, staticRenderFns } from "./Smartphone.vue?vue&type=template&id=764a8954&scoped=true&"
import script from "./Smartphone.vue?vue&type=script&lang=js&"
export * from "./Smartphone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764a8954",
  null
  
)

export default component.exports